module.exports = __webpack_public_path__ + "static/media/icons-ic-decision-call-missed.a11ef3b8.svg";